import { formatInTimeZone } from 'date-fns-tz';
import { logger } from './Debug.js';
import { getDefaultFormats, getDateUtilsConfig, convertZonedDateToSystemDate } from './DateUtils2.js';
import { getIsoDateTime } from './DateUtils8.js';
import { islamicCalendarFormat } from './DateUtils38.js';
import arEG from './ar-EG.js';
import enGB from './en-GB.js';

const baseFormat = (date, options) => {
    var _a, _b, _c, _d, _e, _f, _g;
    let formattedDate = (_a = getIsoDateTime(typeof date === 'string' || typeof date === 'number' ? new Date(date) : date)) !== null && _a !== void 0 ? _a : '';
    if (!date)
        return '';
    const { defaultFormats, timezone } = getDefaultFormats();
    const { locale } = getDateUtilsConfig();
    const localeScript = `${locale}-${islamicCalendarFormat}`;
    const { dateFormat = defaultFormats.dateFormat, skipRTLCharacter = false, calendar = 'gregorian' } = options !== null && options !== void 0 ? options : {};
    try {
        if (calendar === 'hijri') {
            // default format
            let hijriFormatOptions;
            switch (dateFormat) {
                case 'dd/MM/yyyy':
                    hijriFormatOptions = {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                    };
                    break;
                case 'd':
                    hijriFormatOptions = {
                        day: 'numeric',
                    };
                    break;
                case 'EEEEE':
                    hijriFormatOptions = {
                        weekday: 'short',
                    };
                    break;
                case 'EEEEEE':
                    hijriFormatOptions = {
                        weekday: 'short',
                    };
                    break;
                case 'MMM':
                    hijriFormatOptions = {
                        month: 'short',
                    };
                    break;
                case 'MMMM':
                    hijriFormatOptions = {
                        month: 'long',
                    };
                    break;
                case 'yyyy':
                    hijriFormatOptions = {
                        year: 'numeric',
                    };
                    break;
                case 'MM/yyyy':
                    hijriFormatOptions = {
                        year: 'numeric',
                        month: '2-digit',
                    };
                    break;
                case 'HH:mm':
                    hijriFormatOptions = {
                        hour: '2-digit',
                        minute: '2-digit',
                    };
                    break;
                default:
                    hijriFormatOptions = {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                    };
                    break;
            }
            const format = new Intl.DateTimeFormat(localeScript, Object.assign({}, hijriFormatOptions));
            let parts = [];
            const systemDate = convertZonedDateToSystemDate(typeof date === 'string' || typeof date === 'number' ? new Date(date) : date);
            switch (dateFormat) {
                case 'dd/MM/yyyy':
                    parts = format.formatToParts(systemDate);
                    formattedDate = `${(_c = (_b = parts.find((p) => p.type === 'day')) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : ''}/${(_e = (_d = parts.find((p) => p.type === 'month')) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : ''}/${(_g = (_f = parts.find((p) => p.type === 'year')) === null || _f === void 0 ? void 0 : _f.value) !== null && _g !== void 0 ? _g : ''}`;
                    break;
                default:
                    formattedDate = format.format(systemDate);
                    break;
            }
        }
        else {
            // gregorian
            formattedDate = formatInTimeZone(date, timezone, dateFormat, {
                locale: locale === 'ar' ? arEG : enGB,
            });
        }
    }
    catch (ex) {
        logger.error(ex);
    }
    return skipRTLCharacter ? formattedDate : `‎${formattedDate}`;
};

export { baseFormat };
